import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { massMessageService } from '@/modules/online-mass-messages/service/mass-message-service.ts'
import { handleError } from '@/utils/error'

interface UseMassMessageProps {
  messageId: string | undefined
  copy: boolean
  creatorId: number | undefined
}

export const useMassMessage = ({
  messageId,
  copy = false,
  creatorId,
}: UseMassMessageProps) => {
  const query = useQuery(
    ['mass-message', messageId, creatorId],
    () =>
      massMessageService.getMassMessageById({
        creatorId,
        messageId,
      }),
    {
      select: (response) => {
        if (copy) {
          // We filter out id, startsAt and expiresAt when a user wants to duplicate a mass message
          const { id, startsAt, expiresAt, ...newMessage } = response.message

          return { ...response, message: newMessage }
        }

        return response
      },
      enabled: !!creatorId,
      cacheTime: 0,
      keepPreviousData: false,
      onError: (error) => handleError(error, 'Failed to get mass message'),
    },
  )

  return useMemo(
    () => ({
      data: query.data,
      isFetching: query.isFetching || query.isIdle,
    }),
    [query.data, query.isFetching, query.isIdle],
  )
}
